var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEffetMerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_57",
    "data-name": "Groupe 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 293.488,
    height: 213.842,
    viewBox: "0 0 293.488 213.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 293.488,
    height: 213.842,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_54",
    "data-name": "Groupe 54"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_53",
    "data-name": "Groupe 53",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_35",
    "data-name": "Trac\\xE9 35",
    d: "M64.145,214.055a85.42,85.42,0,0,1-10.125-.593c-26.959-3.228-46.627-18.544-51.332-39.97-4.917-22.384-.744-40.813,11.745-51.89,12.261-10.875,31.139-12.979,51.786-5.772,4.119,1.44,7.771,1.052,10.845-1.147a9.385,9.385,0,0,0,0-14.879c-3.071-2.2-6.723-2.588-10.842-1.147-21.367,7.459-40.858,4.988-53.477-6.777C.436,80.4-3.106,62.213,2.768,40.662,11.544,8.484,41.687-2.4,67.7,1.071c37.672,5.045,54.828,32.209,54.828,55.313a6.879,6.879,0,1,1-13.757,0c0-24.688-22.238-38.91-42.9-41.677C47.3,12.221,23.079,18.47,16.042,44.281c-4.466,16.383-2.306,29.713,6.083,37.537,8.628,8.045,23.415,9.487,39.558,3.849,8.349-2.911,16.654-1.87,23.385,2.948a23.137,23.137,0,0,1,0,37.258c-6.731,4.816-15.034,5.859-23.385,2.946-15.8-5.518-29.7-4.395-38.123,3.076-8.593,7.622-11.234,21.347-7.438,38.646,3.464,15.772,18.242,26.711,39.534,29.26,31.978,3.838,55.073-11.915,63.01-28.16a6.879,6.879,0,1,1,12.36,6.041c-12.551,25.685-41.632,36.372-66.882,36.372",
    transform: "translate(0 -0.287)",
    fill: "#fff8f1"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_56",
    "data-name": "Groupe 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_55",
    "data-name": "Groupe 55",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_36",
    "data-name": "Trac\\xE9 36",
    d: "M437.805,213.84a6.88,6.88,0,0,1-5.393-11.142c32-40.527,65.818-124.644,43.268-170.73-9.063-18.507-27.458-21.67-40.944-15.228s-24.454,24.29-10.918,53.389c12.546,26.97,6.693,42.507,3.593,47.936-5.178,9.07-11.871,11.369-16.573,11.7-7.464.505-15.208-3.552-20.9-10.894-6.038-7.779-4.866-16.505-4.009-22.877a42.607,42.607,0,0,0,.519-5.427c-.057-11.788-5.326-19.68-14.459-21.653C361.75,66.706,347.7,72.473,340.67,87.788c-16.267,35.458,4.071,58.961,32.22,91.492,6.443,7.447,13.107,15.149,19.637,23.418a6.879,6.879,0,0,1-10.8,8.526c-6.338-8.027-12.9-15.61-19.244-22.943-27.912-32.259-54.277-62.728-34.321-106.23,10.049-21.9,31.089-29.957,46.724-26.584C390.417,58.821,400.115,72.246,400.2,90.5a53.111,53.111,0,0,1-.642,7.323c-.785,5.838-1.091,9.6,1.244,12.609,2.749,3.544,6.392,5.79,9.066,5.606,1.975-.14,3.858-1.755,5.6-4.8,3.278-5.742,3.918-18.035-4.119-35.311C394.706,40.166,408.127,14.2,428.812,4.325c19.123-9.128,46.375-4.658,59.224,21.6,25.335,51.774-9.754,140.883-44.827,185.3a6.866,6.866,0,0,1-5.4,2.616",
    transform: "translate(-203.184 0)",
    fill: "#fff8f1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffetMerLogo);
export default __webpack_public_path__ + "static/media/Effet_Mer-logo.7cca28ec419635516824f6b019f47736.svg";
export { ForwardRef as ReactComponent };